/**
 * @author      matthew@zumper.com (Matthew Talamini)
 * @copyright   Copyright (c) 2021, Zumper
 */

import { useTheme } from '@emotion/react'

import { IconProps } from '../../types'

export const ExternalLink = ({ fill, size = 15, ...rest }: IconProps) => {
  const { colors } = useTheme()

  return (
    <svg
      fill="none"
      height={(14 / 15) * size}
      viewBox="0 0 15 14"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        clipRule="evenodd"
        d="M0.562866 3.16089L5.55176 3.16089C6.01553 3.16089 6.39149 3.51627 6.39149 3.95466C6.39149 4.39304 6.01553 4.74843 5.55176 4.74843L2.24234 4.74843L2.24234 12.3121L10.2442 12.3121L10.2442 8.88226C10.2442 8.44387 10.6202 8.08849 11.084 8.08849C11.5477 8.08849 11.9237 8.44387 11.9237 8.88226L11.9237 13.8997L0.562866 13.8997L0.562866 3.16089Z"
        fill={fill ?? colors.text}
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M11.5173 4.35969L11.5094 5.27819C11.5057 5.69902 11.8637 6.04328 12.3089 6.0471C12.7541 6.05093 13.118 5.71288 13.1216 5.29205L13.1445 2.646C13.1487 2.15471 12.7306 1.75294 12.2108 1.74893L9.41152 1.7273C8.96631 1.72386 8.60278 2.06223 8.59955 2.48306C8.59632 2.9039 8.95461 3.24785 9.39982 3.25129L10.4005 3.25902L6.77728 6.68389C6.4626 6.98134 6.46283 7.46382 6.7778 7.76155C7.09276 8.05927 7.60318 8.0595 7.91786 7.76205L11.5173 4.35969Z"
        fill={fill ?? colors.text}
        fillRule="evenodd"
      />
    </svg>
  )
}
